export const serviceURLs: any = {
  tenant: 'tenant_service_URL',
  shipment: 'shipment_service_URL',
  document: 'document_service_URL',
  transport: 'transportation_service_URL',
  invoicing: 'invoicing_service_URL',
  contract: 'contract_service_URL',
  product: 'product_service_URL',
  currency: 'currency_service_URL',
  order: 'order_service_URL',
  quote: 'quote_service_URL',
  tendering: 'tendering_service_URL',
  exception: 'exception_service_URL',
  tracking: 'tracking_service_URL',
  edi: 'edi_service_URL'
};

//eslint-disable-next-line
export enum HttpStatus {
  Ok = 200,
  Created = 201,
  BadRequest = 400,
  UnAuthorized = 401,
  ForbiddenRequest = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  Conflict = 409,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnAvailable = 503
}
